import classNames from 'classnames';
import { h, JSX } from 'preact';

export interface CheckboxProps {
    label: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    isDisabled?: boolean;
    class?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export const Checkbox = (props: CheckboxProps): JSX.Element => (
    <div
        class={classNames('mb-4 last:mb-0', props.class)}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
    >
        <label
            class={classNames(
                'inline-flex items-center cursor-pointer k-body k-checkbox-label',
                { 'text-neutral-400 k-checkbox-label--disabled is-disabled': props.isDisabled },
            )}
        >
            <input
                type='checkbox'
                class={classNames(
                    'mr-2 k-checkbox',
                    { 'hover:border': props.isDisabled }
                )}
                checked={props.checked}
                onChange={(): void => props.onChange?.(!props.checked)}
                disabled={props.isDisabled}
            />
            {props.label}
        </label>
    </div>
);
